/**
 * @file src/hooks/useHandleLogout.ts
 * @exports useHandleLogout
 * @summary Clears obsolete invite storage and cached queries before logout.
 */
import { useQueryClient } from "@tanstack/react-query";

import { navigateApp } from "src/lib/app-router";
import { paths } from "src/const";
import { clearLegacyInviteStorage } from "src/views/CreateInviteView/state";

export const useHandleLogout = () => {
	const queryClient = useQueryClient();

	const handleLogout = () => {
		// bust the query cache
		queryClient.resetQueries();

		clearLegacyInviteStorage();
		localStorage.removeItem("order");

		navigateApp({ href: paths.logout });
	};

	return handleLogout;
};
